import {
  FilterParameter,
  makeQuery,
  RangeParameter,
  SortParameter,
} from "api/api";
import * as z from "zod";
import { ApiEndpoints } from "api/endpoints";
import { ResultSchema } from "model/result/schema";

const FetchResultsSchema = z.object({
  success: z.literal(true),
  data: z.array(ResultSchema),
  metadata: z.object({
    count: z.number(),
  }),
});

export const fetchResults = async (
  range: RangeParameter,
  sort?: SortParameter,
  filter?: FilterParameter
) => {
  const response = await makeQuery(
    ApiEndpoints.resultList(),
    true,
    sort,
    range,
    filter
  );
  return FetchResultsSchema.parse(response);
};
